import { createSupabaseAdminClient } from "../../supabase/supabase";

export async function getCollectionIDsForSpecial(
  specialId: string
): Promise<string[]> {
  const supabase = createSupabaseAdminClient();
  const { data, error } = await supabase
    .from("collection_specials")
    .select("collection_id")
    .eq("special_id", specialId);

  if (error) throw error;
  return data.map((row) => row.collection_id);
}

export async function getSpecialIDsForCollection(
  collectionId: string
): Promise<string[]> {
  const supabase = createSupabaseAdminClient();
  const { data, error } = await supabase
    .from("collection_specials")
    .select("special_id")
    .eq("collection_id", collectionId);

  if (error) throw error;
  return data.map((row) => row.special_id);
}
